import React, { useEffect, useState } from "react";
import { ReactComponent as LogoutSvg } from "../../../assets/svg/log_out.svg";
import "../../../css/logout-button.css";
import userApi from "../../../api/userApi";
import userStore from "../../../store/userStore";
import Button from "../../Button";
import { showModal } from "../../../helperComponents/ModalWrapper";
import ModalSure from "../../../templates/ModalSure";
import { fetchWithAbort } from "../../../utils/fetchWithAbort";

const SteamLogoutButton = () => {
  const [isSure, setIsSure] = useState(false);
  const [modal, setModal] = useState(<></>);

  useEffect(() => {
    const controller = new AbortController();
    const { signal } = controller;

    const handleLogout = async () => {
      try {
        const userInfo = await fetchWithAbort(
          (signal) => userApi.logout(signal),
          signal
        );
        userStore.setIsAuth(false);
        userStore.setData({});
        console.log(userInfo);
      } catch (err) {
        console.error(err);
      }
    };

    if (isSure) {
      handleLogout();
    }

    return () => {
      controller.abort();
    };
  }, [isSure]);

  function handleLogoutClick() {
    const newModal = showModal({
      onClose: () => {
        setIsSure(false);
        setModal(<></>);
      },
      children: (
        <ModalSure
          onSure={() => setIsSure(true)}
          text={<p>Вы уверены что хотите выйти из аккаунта?</p>}
        />
      ),
    });
    setModal(newModal);
  }

  return (
    <>
      <button
        onClick={handleLogoutClick}
        className="small-text gradient-text logout"
      >
        <LogoutSvg />
        выйти
      </button>
      {modal}
    </>
  );
};

export default SteamLogoutButton;
